module.exports = __webpack_public_path__ + "static/media/quote-grey-default.98ed2c11.png";